var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-empty"},[_c('h3',[_c('t',{attrs:{"name":"1.7.2"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }